import * as React from 'react';

interface Props {
  image: string;
  text: string;
  alignment: 'left' | 'right' | 'center';
}

const CarouselSlideFooter = ({image, text, alignment}: Props) => {
  return (
    <div className={`carousel-footer ${alignment}`}>
      {image && <img alt="" src={image} />}
      {text && <span className="carousel-footer__text">{text}</span>}
    </div>
  );
};

export default CarouselSlideFooter;
